import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 30AC82B4-6073-462B-B63E-0F64706AAC2F
 * name leaf
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/leaf.svg
 * tags
 * - Nature 
 * - Food / Drink 
 * - Agriculture 
 */
export const LeafIcon = createSvgIcon(<><path d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z" /></>, 'LeafIcon');
export default LeafIcon